import { render, staticRenderFns } from "./pages13.vue?vue&type=template&id=55cb28fe&scoped=true&"
import script from "./pages13.vue?vue&type=script&lang=js&"
export * from "./pages13.vue?vue&type=script&lang=js&"
import style0 from "./pages13.vue?vue&type=style&index=0&id=55cb28fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cb28fe",
  null
  
)

export default component.exports